import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { darken, lighten, styled } from '@mui/material/styles';

const CorrectionDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .correction-grid-ORIGINAL': {
      backgroundColor: theme.palette.correctionGrid.originalRow.primary,
      '&:hover': {
        backgroundColor: theme.palette.correctionGrid.originalRow.secondary
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.correctionGrid.originalRow.secondary,
        '&:hover': {
          backgroundColor: theme.palette.correctionGrid.originalRow.secondary,
        },
      },
    },
    '& .correction-grid-CORRECTED': {
      backgroundColor: theme.palette.correctionGrid.correctedRow.primary,
      '&:hover': {
        backgroundColor: theme.palette.correctionGrid.correctedRow.secondary
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.correctionGrid.correctedRow.secondary,
        '&:hover': {
          backgroundColor: theme.palette.correctionGrid.correctedRow.secondary,
        },
      },
    },
    '& .correction-grid-CORRECTION': {
      backgroundColor: theme.palette.correctionGrid.correctionRow.primary,
      '&:hover': {
        backgroundColor: theme.palette.correctionGrid.correctionRow.secondary
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.correctionGrid.correctionRow.secondary,
        '&:hover': {
          backgroundColor: theme.palette.correctionGrid.correctionRow.secondary,
        },
      },
    },
    '& .correction-grid-ADDED': {
      backgroundColor: theme.palette.correctionGrid.correctedRow.primary,
      '&:hover': {
        backgroundColor: theme.palette.correctionGrid.correctedRow.secondary
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.correctionGrid.correctedRow.secondary,
        '&:hover': {
          backgroundColor: theme.palette.correctionGrid.correctedRow.secondary,
        },
      },
    },
  }));

  export default CorrectionDataGrid;
  